import { Route, Routes } from "react-router-dom";

import Home from "../pages/home/Home";
import Services from "../pages/home/Services";
import About from "../pages/home/About";
import Contact from "../pages/home/Contact";
import Article from "../pages/home/Article";

import RestaurantsList from "../pages/customer/RestaurantsList";
import RestaurantDetails from "../pages/customer/RestaurantDetails";
import ReservationPage from "../pages/customer/ReservationPage";
import ReservationResult from "../pages/customer/ReservationResult";
import MyReservations from "../pages/customer/MyReservations";

import MenuDisplayPage from "../pages/view/MenuDisplayPage";
import RestaurantInfoPage from "../pages/view/components/InfoPage";
import ReviewForm from "../pages/view/components/ReviewForm";
import ClubJoinPage from "../pages/view/ClubJoinPage";

import CartPage from "../pages/CartPage";
import FoodDetailPage from "../pages/FoodDetailPage";

import PaymentVerify from "../pages/payment/Verify";
import OrderSuccess from "../pages/OrderSuccess";

import AuthRestaurant from "../pages/auth/Restaurant/Auth";

const PublicRoutes = () => {
  return (
    <Routes>

      <Route
        path="/auth/restaurant"
        element={<AuthRestaurant />}
      />

      <Route path="/" element={<Home />} />
      <Route path="/services" element={<Services />} />
      <Route path="/about" element={<About />} />
      <Route path="/contact" element={<Contact />} />
      <Route path="/article" element={<Article />} />

      <Route path="/restaurants" element={<RestaurantsList />} />
      <Route path="/restaurant/:id" element={<RestaurantDetails />} />
      <Route path="/p/reserve/:restaurantId" element={<ReservationPage />} />
      <Route path="/p/reservation-result" element={<ReservationResult />} />
      <Route path="/p/my-reservations" element={<MyReservations />} />

      <Route path="/menu/:menuLink" element={<MenuDisplayPage />} />
      <Route path="/menu/:menuLink/info" element={<RestaurantInfoPage />} />
      <Route path="/menu/:menuLink/ReviewForm" element={<ReviewForm />} />
      <Route path="/menu/:menuLink/club" element={<ClubJoinPage />} />

      <Route path="/menu/:menuLink/item/:itemId" element={<FoodDetailPage />} />
      <Route path="/food/:itemId" element={<FoodDetailPage />} />

      <Route path="/restaurant/cart/:menuLink" element={<CartPage />} />

      <Route path="/payment/verify" element={<PaymentVerify />} />

      <Route
        path="/menu/:menuLink/order-success"
        element={<OrderSuccess />}
      />

    </Routes>
  );
};

export default PublicRoutes;
